export default __webpack_public_path__ + "static/media/Group8921.38bc9833.svg";